module.exports = __webpack_public_path__ + "static/media/speakers_logos_WGBC.d561d74f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/conf/speaker/speakers_logos_WGBC.jpg
// module id = 282
// module chunks = 0